import { useContext, useEffect } from 'react';

import { HouseFIlter } from './HouseFIlter/HouseFilter';
import { GoodsListContext } from '../../Context/GoodsListContext';

export const HouseFIltersList = (houseState) => {
  const {
    state: {
      filters: { house },
    },
    dispatch,
  } = useContext(GoodsListContext);

  useEffect(() => {
    if (houseState.houseState) {
      dispatch({ type: 'filter-change', payload: { house: houseState.houseState } });
    }
  }, []);

  const handleChange = (event) => {
    dispatch({ type: 'filter-change', payload: { house: event.target.id } });
  };
  return (
    <div className="mt-2 md:mt-4">
      <h3 className="font-crimson font-bold text-base md:text-lg leading-5">Hogwarts houses</h3>
      <div>
        {['All houses', 'Gryffindor', 'Slytherin', 'Hufflepuff', 'Ravenclaw'].map((houseFilter, idx) => (
          <HouseFIlter
            key={houseFilter + idx}
            name={houseFilter}
            handleFilter={handleChange}
            isActive={house === houseFilter}
          />
        ))}
      </div>
    </div>
  );
};
